import { useQuery } from "@tanstack/react-query";
import { getUserInfo } from "../api/users/getUserInfo";

export const useUser = ({ enabled }: { enabled: boolean }) => {

  return useQuery({
    queryKey: ["user"],
    queryFn: getUserInfo,
    staleTime: 1000 * 60 * 60,
    retry: 1,
    enabled,
  });
};
